<div class="ex-modal-header">
  <div class="ex-modal-title">
    {{ (promptId ? 'search.prompt-modal.edit-prompt-title' : 'search.prompt-modal.create-prompt-title') | translate }}
  </div>
  <ex-button icon="x-bold" type="secondary" variant="ghost" size="small" (click)="modal.dismiss()"></ex-button>
</div>
<div class="ex-modal-body">
  <div class="input-container modal-title-section">
    <label for="title-input">{{ 'search.prompt-modal.prompt-title' | translate }}</label>
    <div class="input-container-content">
      <input
        id="title-input"
        type="text"
        placeholder="{{ 'search.prompt-modal.prompt-title-placeholder' | translate }}"
        [(ngModel)]="title"
        (blur)="title = title.trim()"
        [maxlength]="PROMPT_TITLE_CHAR_LIMIT"
      />
      <span class="input-limit">{{ title.length }}/{{ PROMPT_TITLE_CHAR_LIMIT }}</span>
    </div>
  </div>
  @if (promptId) {
    <div class="input-container modal-prompt-section">
      <label>{{ 'search.prompt-modal.prompt-content' | translate }}</label>
      <app-smart-search-prompt
        [prompt]="initialPrompt"
        (promptChange)="onPromptChange($event)"
        [allowSave]="false"
        [allowCopy]="false"
        [usePreviewTags]="true"
      />
    </div>
  }
</div>
<div class="ex-modal-footer">
  @if (promptId) {
    <div class="modal-footer-group">
      <ex-button type="danger" variant="ghost" icon="trash-fill" (click)="delete()">
        {{ 'search.prompt-modal.delete-prompt' | translate }}
      </ex-button>
    </div>
  }
  <div class="modal-footer-group">
    <ex-button type="primary" variant="ghost" (click)="cancel()">{{ 'common.cancel' | translate }}</ex-button>
    <ex-button type="primary" variant="raised" [disabled]="!title.trim().length || !prompt.length" (click)="confirm()">
      {{ 'common.save' | translate }}
    </ex-button>
  </div>
</div>
<ng-template #successToast let-toast="toast" let-toastService="toastService">
  <div class="position-relative d-flex w-100 h-100">
    <div class="position-absolute toast-icon-div icon--close align-self-center" (click)="toastService.remove(toast)"></div>
    <img src="assets/images/icon-checkmark-circle.svg" class="align-self-center toast-image" alt="icon-checkmark" />
    <div class="fw-bold align-self-center toast-text">
      <p class="m-0">{{ toast.content | translate: { name: toast.name } }}</p>
    </div>
  </div>
</ng-template>
